import { _ as r } from "./index742.mjs";
import { o as s } from "./index744.mjs";
var a = r, t = s;
a({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== t }, {
  assign: t
});
